import { render, staticRenderFns } from "./ModrEdit.vue?vue&type=template&id=273207a5&scoped=true&"
import script from "./ModrEdit.vue?vue&type=script&lang=js&"
export * from "./ModrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273207a5",
  null
  
)

export default component.exports